export default import.meta.ROLLDOWN_FILE_URL_5_OETkMOTUvelB0ycJ6rag